import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import DisclosureCounselingRepository from '@/repositories/disclosureCounselingRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import { DsclstResponce } from '@/models/disclosureCounseling/disclosureCounselingModel';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useDisclosureCounselingStore = defineStore({
    id: 'disclosureCounseling',
    state: () => ({
        disclosureCounselingList: new DsclstResponce(),
        pageInfo: 0,
    }),
    getters: {},
    actions: {
        /**
         * 開示カウンセリング一覧取得API
         * @param {String} API_URL
         * @param {object} requestBody
         */
        async getDisclosureCounselingListAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const disclosureCounselingRepository = new DisclosureCounselingRepository();
            try {
                const response = await disclosureCounselingRepository.getDisclosureCounselingListApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.disclosureCounselingList = response.data.List;
                this.pageInfo = response.data.PageInfo.RowResult;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
